import { render, staticRenderFns } from "./viewArticle.vue?vue&type=template&id=be9cf5e0&scoped=true&"
import script from "./viewArticle.vue?vue&type=script&lang=js&"
export * from "./viewArticle.vue?vue&type=script&lang=js&"
import style0 from "./viewArticle.vue?vue&type=style&index=0&id=be9cf5e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9cf5e0",
  null
  
)

export default component.exports